import { Injectable } from "@angular/core";
import { JobDescription } from "../../models/domains/pbm/Beneficiary/job-description";
import { JobDescriptionRepository } from "../../repositories/pbm/job-description.repository";

@Injectable({ providedIn: "root" })
export class JobDescriptionService {
  constructor(private jobDescriptionRepository: JobDescriptionRepository) {}

  public async getJobDescription(fiscalNumber: string): Promise<JobDescription[]> {
    return await this.jobDescriptionRepository.getJobDescription(fiscalNumber);
  }

  public async createJobDescription(jobDescription: JobDescription, fiscalNumber: string) {
    return await this.jobDescriptionRepository.createJobDescription(jobDescription, fiscalNumber);
  }

  public async editJobDescription(jobDescription: JobDescription, fiscalNumber: string) {
    return await this.jobDescriptionRepository.editJobDescription(jobDescription, fiscalNumber);
  }

  public async deleteJobDescription(jobDescriptionkey: string, fiscalNumber: string) {
    return await this.jobDescriptionRepository.deleteJobDescription(jobDescriptionkey, fiscalNumber);
  }
}
